@if (syncState$ | async; as syncState) {
    <div (click)="triggerSynchronization()" class="syncIconWrapper cursor-pointer">
        @if (syncState === online) {
            <fa-icon [icon]="faSync" size="lg" class="icon-online"></fa-icon>
        }
        @if (syncState === offline) {
            <fa-icon [icon]="faBan" size="lg" class="icon-offline"></fa-icon>
        }
        @if (syncState === syncing) {
            <fa-icon [icon]="faSync" animation="spin" size="lg" class="icon-online"></fa-icon>
        }
        @if (syncState === pending) {
            <fa-icon [icon]="faUpload" size="lg" class="icon-offline"></fa-icon>
        }
        @if (count$ | async; as count) {
            @if (count > 0) {
                <span class="badge rounded-pill bg-danger">{{ count }}</span>
            }
        }
    </div>
}
